import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Message, SelectItem } from "primeng/components/common/api";
import { AppConstants } from "../core/app.constants";
import { AuthAccessProvider } from "../core/core.auth";
import { BaseComponent, Scadenza, Offer, UserContext, ProjectResponse, Project, UserInfo } from "../core/core.component";
import { BusyProvider } from "../service/busy.service";
import { MessageProvider } from "../service/message.service";
import { UserService } from "../service/user.service";
import { OfferService } from "app/service/offers.service";
import { ScadenzeFatturazioneService } from "app/service/scadenze.service";
import { TaskService } from '../service/task.service';

@Component({
	selector: "app-scadenze-fatturazione",
	templateUrl: "./scadenze-fatturazione.component.html",
	styleUrls: ["./scadenze-fatturazione.component.css"],
})
export class ScadenzeFatturazioneComponent extends BaseComponent implements OnInit {
	offersAttive: Offer[]=[];
	offers: Offer[]=[];
	scadenze: Scadenza[]=[];
	userContext: UserContext;
	userInfo: UserInfo = new UserInfo();
	filteredScadenze: Scadenza[] = [];
	onlyActive: boolean = true;
	onlyActiveFilter: boolean = true;
	nascondiFatturate: boolean =true;
	loading: boolean = false;
	loadingTicket: boolean= false;
	isEditing: boolean = false;
	filterQuery: string = "";
	scadenzaSelected: Scadenza = new Scadenza();
	validationMessage: string = null;
	showDeleteAlert = false;
	commesseOptions : SelectItem[] = [];
	commesseFiltered: SelectItem[] = [];
	locale: any = AppConstants.ITA_CALENDAR_CONF;
	sortField = null;
	sortAsc = false;
	status: string = null;
	titoloCommessa: string=null;
	filterRefOrder: string=null;
	filterDtScadFrom: Date=null;
	filterDtFattFrom: Date=null;
	filterDtScadTo: Date=null;
	filterDtFattTo: Date=null;
	filterTicket: string=null;
	projects: SelectItem[] = []; // ad uso del filtro per task
    forceReloadFilterTask = false;
	idTicketSelected: number=null;
    tasksFiltered: SelectItem[] = [];
	tasks: SelectItem[] = [];
	showFilter: boolean = false;
	idscad: number = null;
    reforder: string = null;
    dscliente: string = null;
    dtscad: Date = null;
    importo: number = null;
    giorni: number = null;
    numfatt: string = null;
    dtfatt: Date = null;
    ticket: string = null;
	descrizione: string = null;
	href: string=null;

	msgs: Message[] = [];

	constructor(
		protected authAccess: AuthAccessProvider,
		protected router: Router,
		protected messageProvider: MessageProvider,
		private userService: UserService,
		private busyProvider: BusyProvider,
		private scadenzeService: ScadenzeFatturazioneService,
		private offerService: OfferService,
		private taskService: TaskService,
		
	) {
		super(authAccess, router, messageProvider);
		this.messageProvider.clearAll();
	}

	ngOnInit() {
		this.userContext = this.authAccess.getUserContext();
		if (this.userContext == null) {
			this.authAccess.invalidate();
		  } else {
			const today = new Date();
			this.filterDtScadTo = new Date(today.getFullYear(), today.getMonth() + 1, 0);
			this.loadScadenze();
			this.loadOffers(false);					//Recupero tutte le offerte
			this.loadOffers(true);					//Recupero solo le offerte attive
			
			
			this.taskService.getUserProjects(this.userContext.srmToken).subscribe(
							response => {
								let projectResponse: ProjectResponse = response;
								for (let i = 0; i < projectResponse.userProjects.length; ++i) {
									let project: Project = projectResponse.userProjects[i];
									this.projects.push({ label: project.name, value: project.id });
								}
								this.caricaIssues();
							},
							error => {
								this.handleError(error);
							}
						);
		
		  }

		  this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
			(result) => {
				this.userInfo = result;
			},
			(error) => {
				this.handleError(error);
			}

		);	
	}

	loadScadenze() {
		this.scadenze = [];
		this.loading = true;
		this.scadenzeService.getScadenze(this.userContext.srmToken, this.filterRefOrder, this.filterDtScadFrom, this.filterDtScadTo, this.filterDtFattFrom, this.filterDtFattTo, this.filterTicket).subscribe(
			(result) => {
				if (result.message) {
					const scadenze = JSON.parse(result.message);
					
					this.scadenze = scadenze;
					this.filterScadenze();
					this.loading = false;
        			if (this.scadenzaSelected != null && this.scadenzaSelected.idscad > 0) {
          				this.selectScadenza(this.scadenzaSelected);
        			}
					this.sort('dtscad');
        			
			}},
			(error) => {
				this.handleError(error);
				this.loading=false;
			}
		);
	}

	storeScadenza() {
		this.messageProvider.clearAll();
		this.validationMessage = null;
		if (this.reforder == null || this.reforder.trim() == "") {
			this.validationMessage = "Inserire Commessa";
			return;
		}
		if (this.descrizione == null || this.descrizione.trim() == "") {
			this.validationMessage = "Inserire la descrizione";
			return;
		}
		if (this.dtscad == null) {
			this.validationMessage = "Inserire la data di scadenza";
			return;
		}
		
		if(this.importo!=null && isNaN(this.importo) || this.importo==null){
			this.validationMessage = "Inserire un importo numerico";
			return;
		}
		if(this.giorni!=null && isNaN(this.giorni)){
			this.validationMessage = "Inserire un valore numerico di giorni";
			return;
		}

			// modifica
		if (this.scadenzaSelected.idscad > 0) {
			this.busyProvider.showBusyIndicator();
			let scadenza: Scadenza = this.buildScadenza();
			scadenza.idscad = this.scadenzaSelected.idscad;
			this.scadenzeService.updateScadenza(this.userContext.srmToken, scadenza).subscribe(
				() => {
					this.busyProvider.hideBusyIndicator();
					this.msgs = [];
					this.msgs.push({ severity: "success", summary: "OK", detail: "Modifica eseguita correttamente" });
					this.scadenzaSelected = scadenza;
					this.loadScadenze();
				},
				(error) => {
					this.busyProvider.hideBusyIndicator();
					this.handleError(error);
				}
			);
		}
		// inserimento
		else {
			
			this.busyProvider.showBusyIndicator();
			let scadenza: Scadenza = this.buildScadenza();
			this.scadenzeService.insertScadenza(this.userContext.srmToken, scadenza).subscribe(
				(result) => {
					this.busyProvider.hideBusyIndicator();
					this.msgs = [];
					this.msgs.push({ severity: "success", summary: "OK", detail: "Scadenza inserita correttamente" });
					scadenza.idscad = Number(result.message);
					this.scadenzaSelected = scadenza;
					this.loadScadenze();

				},
				(error) => {
					this.busyProvider.hideBusyIndicator();
					this.handleError(error);
				}
			);
		}
	}

	buildScadenza(): Scadenza {
		let scadenza: Scadenza = new Scadenza();
		scadenza.dsscad=this.descrizione;
		scadenza.dtfatt=this.dtfatt;
		scadenza.dtscad=this.dtscad;
		scadenza.giorni=this.giorni;
		scadenza.idscad=this.idscad;
		scadenza.importo=this.importo;
		scadenza.numfatt=this.numfatt;
		scadenza.reforder=this.reforder;
		scadenza.dscliente=this.dscliente;
		scadenza.ticket=this.ticket;
		return scadenza;
	}

	selectScadenza(scadenza: Scadenza){
		this.isEditing = false;
		this.validationMessage = null;
		this.idscad=scadenza.idscad;
		this.scadenzaSelected = scadenza;
		if(scadenza.dtscad!=null){
			this.dtscad=new Date(scadenza.dtscad);}
		else{
			this.dtscad=null;}
		if(scadenza.dtfatt!=null){
			this.dtfatt=new Date(scadenza.dtfatt);}
		else{
			this.dtfatt=null;}
		this.giorni=scadenza.giorni;
		this.importo=scadenza.importo;
		this.numfatt=scadenza.numfatt;
		this.reforder=scadenza.reforder;
		this.dscliente=scadenza.dscliente;
		this.descrizione=scadenza.dsscad;
		this.ticket=scadenza.ticket;
		this.idTicketSelected=null;
		this.href=null;
		this.status=null;
		if (this.ticket!=null && this.ticket!="" && this.tasks.length!=0){
			let task = this.tasks.find(t => t.label === this.ticket);
			if(task){
				this.idTicketSelected=task.value.id;
				this.loadingTicket=true;
				this.recuperaTicket(this.idTicketSelected, false);
			}
			else{
				this.status="Non trovato";
			}
		}
			
		
	}

	addNewScadenza() {
		this.isEditing = true;
		this.validationMessage = null;
		this.messageProvider.clearAll();
		this.scadenzaSelected = new Scadenza();
		this.idscad=null;
		this.descrizione=null;
		this.dtfatt=null;
		this.dtscad=null;
		this.giorni=null;
		this.importo=null;
		this.numfatt=null;
		this.reforder=null;
		this.dscliente=null;
		this.ticket=null;
	}

	filterScadenze(){
		this.filteredScadenze=this.scadenze;
		if (this.filterQuery != null && this.filterQuery.trim() != "") {
			this.filteredScadenze = [];
			for (let i = 0; i < this.scadenze.length; ++i) {
				let reforder = this.scadenze[i].reforder;
				let filterQuery = this.filterQuery;
				if ((reforder && filterQuery && reforder.toLowerCase().indexOf(filterQuery.toLowerCase()) >= 0))
				{
					this.filteredScadenze.push(this.scadenze[i]);
				}
			}
		}
		if (this.filteredScadenze.length == 1) {
			this.scadenzaSelected = this.filteredScadenze[0];
			this.selectScadenza(this.scadenzaSelected);
		}
	}

	openDeleteAlert(current: Scadenza) {
		this.selectScadenza(current);
		this.showDeleteAlert = true;
	  }

	  closeDeleteAlert() {
		this.showDeleteAlert = false;
	  }
	
	  deleteScadenza() {
		this.messageProvider.clearAll();
		this.validationMessage = null;
	
		this.busyProvider.showBusyIndicator();
		this.scadenzeService.deleteScadenza(this.userContext.srmToken, this.idscad).subscribe(
		  result => {
			this.busyProvider.hideBusyIndicator();
			this.msgs = [];
			this.msgs.push({severity: 'success', summary: 'OK', detail: 'Cancellazione eseguita correttamente'});
			this.addNewScadenza();
			this.loadScadenze();
		  },
		  error => {
			this.busyProvider.hideBusyIndicator();
			this.handleError(error);
		  });
	  }

	  sort(field: string, asc?: boolean) {
		if (field === this.sortField && (typeof asc === 'undefined' || asc == !this.sortAsc)) {
		  this.filteredScadenze = this.filteredScadenze.reverse();
		  this.sortAsc = !this.sortAsc;
		} else {
		  this.sortField = field;
		  this.sortAsc = true;
		  this.filteredScadenze = this.filteredScadenze.sort((a1, a2) => {
			var res = 0;
			if (this.sortField === 'cliente') {
			  res = this.compareStrings(a1.dscliente, a2.dscliente);
			} else if (this.sortField === 'commessa') {
			  res = this.compareStrings(a1.reforder, a2.reforder);
			} else if (this.sortField === 'descrizione') {
			  res = this.compareStrings(a1.dsscad, a2.dsscad);
			} else if (this.sortField === 'dtscad') {
				res = this.compareDates(a1.dtscad, a2.dtscad);
			} else if (this.sortField === 'numfatt') {
				res = this.compareStrings(a1.numfatt, a2.numfatt);
			} else if (this.sortField === 'ticket') {
				res = this.compareStrings(a1.ticket, a2.ticket);
			} else if (this.sortField === 'dtfatt') {
				res = this.compareDates(a1.dtfatt, a2.dtfatt);
			} else if (this.sortField === 'importo') {
				res = a1.importo > a2.importo ? 1 : -1;
			}return this.sortAsc ? res : -res;
		  });
		}
	  }

	  private compareStrings(s1: string, s2: string) {
		return (s1 ? s1.toLowerCase() : '') > (s2 ? s2.toLowerCase() : '') ? 1 : -1;
	  }

	  private compareDates(d1: Date, d2: Date) {
		if (!d1 && !d2) {
		  return 0;
		} else if (!d1) {
		  return -1;
		} else if (!d2) {
		  return 1;
		} else {
		  return +new Date(d1) - +new Date(d2);
		}
	  }

	  toggleFilter() {
		this.showFilter = !this.showFilter;
	  }

	  applyFilter() {
		this.loadScadenze();
		this.showFilter = false;
	}

	loadOffers(onlyActive?:boolean) {
		this.offers = [];
		this.offerService.getOffers(this.userContext.srmToken, onlyActive).subscribe(
			(result) => {
				if (result.message) {
					try {
						const offers = JSON.parse(result.message);
						
						if (!offers || offers.length === 0) {
							console.warn("Nessuna commessa trovata!");
							return;
						}

						if(onlyActive){
							this.offersAttive=offers;
						}
						else{
							this.offers=offers;
						}
						
						
				} catch (e) {
						console.error("Errore nel parsing JSON:", e);
					}
			}},
			(error) => {
				this.handleError(error);
				this.loading=false;
			}
		);
	}


	removeFilter() {
		this.resetFilter();
		this.loadScadenze();
		this.showFilter = false;
	}
	
	resetFilter() {
		this.filterRefOrder=null;
		this.filterDtFattFrom=null;
		this.filterDtScadFrom=null;
		this.filterDtFattTo=null;
		this.filterDtScadTo=null;
		this.filterTicket=null;
		
	}

	filterOffer(event, isFilter) {
		this.caricaSuggerimentiCommesse(isFilter);
		this.commesseFiltered = AppConstants.filterSuggestions(this.commesseOptions, event.query, item => [item.label, item.value]);
	  }

	  onSelectOffer(offer: any, isFilter: boolean) {
		if(!isFilter){
			this.reforder = offer.value;
			this.titoloCommessa = offer.value+" - "+offer.label;
			const source = this.onlyActive ? this.offersAttive : this.offers;
			const fullOffer = source.find(o => o.reforder === offer.value);
			this.dscliente = fullOffer ? fullOffer.dscliente : null;
		}
		else{
			this.filterRefOrder = offer.value;
		}
	  }

	  onSelectTicketFilter(task: any) {
		this.filterTicket = task.value ? task.value.issueNo : null;
	  }

	  caricaSuggerimentiCommesse(isFilter: boolean){
		let offerte;
		if((isFilter && this.onlyActiveFilter) || (!isFilter && this.onlyActive)){
			offerte=this.offersAttive;
		}
		else{
			offerte=this.offers;
		}
		this.commesseOptions = offerte				//ordine alfabetico dei clienti nel dropdown
			.map(offer => ({
				label: offer.dsofferta,
				value: offer.reforder
			}))
			.sort((a, b) => a.label.localeCompare(b.label, 'it', { sensitivity: 'base' }));
	  }

	  caricaIssues(){
		this.tasks=[];
		const projectIds = (this.projects.find(p => p.label.includes("SITECH"))).value;
        this.taskService.searchTaskByProject(this.userContext.srmToken, "SIT", projectIds, 10000, this.forceReloadFilterTask).subscribe(
            result => {
                this.forceReloadFilterTask = false;
				result.issues.forEach(issue => {
                    this.tasks.push({ label: issue.issueNo, value: issue });
                });
            }
        );
	  }

	  filterTask(event) {
		this.tasksFiltered = [];
		if (this.tasks.length == 0) {
			this.tasksFiltered.push({ label: 'Caricamento in corso...', value: '' });
		} else {
			const query = event.query.toLowerCase();
	
			this.tasks
				.filter(issue =>
					issue.value.issueNo.toLowerCase().includes(query) ||
					issue.value.title.toLowerCase().includes(query)
				)
				.forEach(issue => {
					this.tasksFiltered.push({
						label: issue.value.issueNo + ' - ' + issue.value.title,
						value: issue.value
					});
				});
		}
	}
	

	recuperaTicket(id: number, onTaskSelected: boolean) {
		const projectIds = (this.projects.find(p => p.label.includes("SITECH"))).value;
		this.taskService.getIssueById(this.userContext.srmToken, id, projectIds, false).subscribe(
			(result) => {
				if (result) {
					try {
						if(result.issues.length!=0)	{
							if(this.idTicketSelected==result.issues[0].id || onTaskSelected){ //controllo che l'utente non abbia selezionato un'altra scadenza prima del recupero di questi dati
							this.status=result.issues[0].status.name;
							this.href=result.issues[0].href;
							if(onTaskSelected){	//Aggiorno la stima del tempo solo all'aggiunta di un nuovo task
								let tempoStimato=result.issues[0].estimatedTime;
								if (tempoStimato!=null){
									this.giorni = tempoStimato.months * 30 + tempoStimato.weeks * 7 + tempoStimato.days + Math.round(tempoStimato.hours / 8);
								}
							}
							this.loadingTicket=false;
						}
					}else{
						this.status="Status del ticket non trovato";
						this.loadingTicket=false;
					}

				} catch (e) {
						console.error("Errore", e);
					}
			}
			else{
				this.status="Status del ticket non trovato";
		}},
			(error) => {
				this.handleError(error);
				this.loading=false;
			}
		);
	}

	onTaskSelected(event){
		this.ticket=event.value.issueNo;
		this.idTicketSelected=event.value.id;
		this.loadingTicket=true;
		this.status=null;
		this.recuperaTicket(event.value.id, true);
	}

	changeStatusToFatturato() {
		this.validationMessage = null;
		if (this.dtfatt == null) {
			this.validationMessage = "Inserire la data di fatturazione prima di procedere";
			return;
		}
		const mesi = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
		              'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
		const data = new Date(this.dtfatt);
		const commento = 'Fatturato nel mese di ' + mesi[data.getMonth()] + ' ' + data.getFullYear() + ' (operazione eseguita tramite SRM)';
		this.taskService.changeTaskStatusAdvanced(this.userContext.srmToken, this.idTicketSelected, ['CHIUSO'], commento).subscribe(
			() => {
				this.recuperaTicket(this.idTicketSelected, false);
			},
			(error) => {
				this.handleError(error);
			}
		);
	}
	
	get isDetailReadonly(): boolean {
		return this.scadenzaSelected.idscad > 0 && !this.isEditing;
	}

	get totaleImporto(): number {
		return this.filteredScadenze
			.filter(s => !(this.nascondiFatturate && s.dtfatt != null))
			.reduce((sum, s) => sum + (s.importo || 0), 0);
	}

	recuperaLink(issueNo: string): string{
		let result = null;
		if(this.tasks.length!=0 && issueNo!=null){
			let task = this.tasks.find(t => t.label === issueNo);
			if(task){
				result= task.value.href;}
		}
		return result;}

    formatImporto(value: any): string {
        if (value == null || value === '') return '';
        const num = Number(value);
        if (isNaN(num)) return '';
        return num.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
}



// WEBPACK FOOTER //
// ./src/app/scadenze-fatturazione/scadenze-fatturazione.component.ts